import { ErrorHandlerFn, ErrorResponse } from './types';

let customHandleError: ErrorHandlerFn | null = null;

export const setErrorHandler = (handler?: ErrorHandlerFn) => {
	customHandleError = handler ?? null;
};

const normalizeError = (error: any): ErrorResponse => {
	if (error instanceof Response) {
		return {
			error: {
				code: error.status,
				message: error.statusText,
			},
		};
	}
	if (error instanceof Error) {
		return {
			error: {
				code: 500,
				message: error.message,
			},
		};
	}
	return {
		error: {
			code: 500,
			message: 'Unknown error',
		},
	};
};

export const handleError = (error: any): ErrorResponse => {
	const normalized = normalizeError(error);
	if (customHandleError) {
		return customHandleError(normalized);
	}
	return normalized;
};
